//namespace Pacem.Geometry {
import { Vector3D } from './geom3d';
//#region Utils
export class Utils3D {
    /**
     * Computes the intersection between a ray and a triangle in the 3D space - if any - using the Möller–Trumbore algorithm.
     * @param ray Array of two points identifying a ray.
     * @param triangle Array of three points identifying a triangle.
     * @returns Intersection point if any, otherwise null.
     */
    static intersect(ray, triangle) {
        // Möller–Trumbore algorithm
        const [start, end] = ray;
        const vector = Vector3D.subtract(start, end);
        const [a, b, c] = triangle;
        const ab = Vector3D.subtract(a, b);
        const ac = Vector3D.subtract(a, c);
        const cross = Vector3D.cross(vector, ac);
        const det = Vector3D.dot(ab, cross);
        if (det.isCloseTo(0)) {
            return null;
        }
        const invDet = 1 / det;
        const s = Vector3D.subtract(start, a);
        const u = invDet * Vector3D.dot(s, cross);
        if (u < 0 || u > 1) {
            return null;
        }
        const scross = Vector3D.cross(s, ab);
        const v = invDet * Vector3D.dot(vector, scross);
        if (v < 0 || (u + v) > 1) {
            return null;
        }
        const t = invDet * Vector3D.dot(ac, scross);
        if (t < 0 || t.isCloseTo(0)) {
            return null;
        }
        return Vector3D.add(start, Vector3D.scale(vector, t));
    }
}
//#endregion
//}
